import { handleActions } from 'redux-actions';

import { NAMES as GET_BUSINESS_MANAGER_SETTINGS } from 'shared/redux/server/actions/business-manager-settings/business-manager-settings';


const defaultState = {
  inBizManager: false,
};


export default handleActions({
  [GET_BUSINESS_MANAGER_SETTINGS.SUCCESS]: (state, { payload: { response } }) => ({ ...defaultState, ...response }),
  [GET_BUSINESS_MANAGER_SETTINGS.FAIL]: _.constant(defaultState),
}, null);



// WEBPACK FOOTER //
// ./src/shared/redux/client/reducers/business-manager-settings.js